import React from 'react'

export default class ErrorPage extends React.Component {



    render() {

        return (
            <div className = "error-page">
                <h1>Something is not quite right with us.</h1>
                <h2>Please check back again soon.</h2>
            </div>
        )
    }
}
